import React, {Component} from 'react';
import {ChangeMonth, ChangeQuarter, ChangeYear} from 'invoices/Options';
import {Col, Row, Nav, NavItem, NavLink} from 'reactstrap';
import autobind from 'autobind-decorator';
import {connect} from 'react-redux';
import * as items from 'items/actions/items';

@connect(
    null,
    dispatch => {
        return {
            setCurrentType: type => dispatch(items.setCurrentType(type))
        }
    }
)
export default class ItemContainer extends Component {

    @autobind
    changeType(type) {
        this.props.setCurrentType(type);
    }

    render() {
        return (
            <Row>
                <Col sm={2} className='mt-3'>
                    <Nav vertical>
                        <NavItem>
                            <ChangeYear callback={this.props.callback}/>
                        </NavItem>
                        <NavItem>
                            <ChangeQuarter callback={this.props.callback}/>
                        </NavItem>
                        <NavItem>
                            <ChangeMonth callback={this.props.callback}/>
                        </NavItem>
                        <hr/>
                        <NavItem>
                            <NavLink to='/items' href="#" onClick={() => this.changeType(-1)}>
                                Gesamt
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to='/items' href="#" onClick={() => this.changeType(0)}>
                                Bank
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="/items" href='#' onClick={() => this.changeType(1)}>
                                Kassenbuch
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="/items" href="#" onClick={() => this.changeType(2)}>
                                Sonstiges
                            </NavLink>
                        </NavItem>
                        <hr/>
                        <NavItem>
                            <NavLink to="/overview">
                                Übersicht
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
                <Col sm={10} className='mt-3'>
                    {this.props.children}
                </Col>
            </Row>
        )
    }
}
